// extracted by mini-css-extract-plugin
module.exports = {"Text":"Power_Text__2UATg","Value":"Power_Value__3KXIF","Small":"Power_Small__1a3zc","Unit":"Power_Unit__2WWJI"};